.result {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
}

.name {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
  overflow-wrap: anywhere;
}

.tags {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-3);
}

.chip {
  border-radius: 4px;
  padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-2);
  white-space: nowrap;
}

.info {
  background-color: var(--pgm-sys-color-info-container);
  color: var(--pgm-sys-color-on-info-container);
}

.success {
  background-color: var(--pgm-sys-color-success-container);
  color: var(--pgm-sys-color-on-success-container);
}

.grid {
  display: grid;
  gap: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-10);
  grid-template-columns: minmax(0, 0.25fr) minmax(0, 1fr);
}

.field {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-2);
  min-width: 0;
}

.fieldLabel {
  color: var(--pgm-sys-color-on-surface);
}

.fieldValue {
  color: var(--pgm-sys-color-on-surface-variant);
  overflow-wrap: anywhere;
}

@media (max-width: 1024px) {
  .grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
